import { Box } from '@mui/material';

import TelegramIcon from '../../icons/telegram-icon';
import TelegramIcons from '../../icons/telegram-icons';
import Tiktok from '../../icons/tiktok';
import Twitch from '../../icons/twitch';
import TwitterIcon from '../../icons/twitter-icon';
import WhatsappIcon from '../../icons/whatsapp-icon';
import ToggleSwitchMode from '../../ToggleSwitchMode';

const DrawerMenuRedesSociales = ({ displayToogle = false }) => {
    const color = '#ccc';

    return (
        <Box
            height={45}
            display="flex"
            alignItems="center"
            gap={0.5}
            px={1}
            width="100%"
            justifyContent="space-between"
        >
            <Box display="flex" alignItems="center" gap={0.5}>
                <TwitterIcon
                    color={color}
                    onClick={() => window.open('https://twitter.com/AnaliticaLaLiga', '_blank')}
                />
                <Tiktok
                    color={color}
                    width={18}
                    height={18}
                    onClick={() => window.open('https://www.tiktok.com/@analitica.fantasy', '_blank')}
                />
                <TelegramIcon
                    onClick={() => window.open('https://t.me/+pOyVGp5tSEpkMzBh', '_blank')}
                    color={color}
                />
                <TelegramIcons
                    onClick={() => window.open('https://t.me/+9Qf0bWVpF35jNWEx', '_blank')}
                    color={color}
                />
                <WhatsappIcon
                    color={color}
                    width={20}
                    height={20}
                    onClick={() =>
                        window.open('https://whatsapp.com/channel/0029VawDrasLtOjKouGAfp24', '_blank')
                    }
                />
                <Twitch color={color} width={18} height={18} />
            </Box>
            {displayToogle && (
                <Box display="flex" alignItems="center" gap={1}>
                    <ToggleSwitchMode />
                </Box>
            )}
        </Box>
    );
};

export default DrawerMenuRedesSociales;
